import React from 'react';
function Uppercase({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={stroke}
      stroke="none"
      {...otherProps}
    >
      <path
        d="M2.95578 18.2116H1L5.39453 5.99997H7.52323L11.9178 18.2116H9.96199L6.50956 8.21811H6.41416L2.95578 18.2116ZM3.28373 13.4295H9.62807V14.9798H3.28373V13.4295Z"
        fill="currentColor"
      />
      <path
        d="M20.5216 10.0248C20.4063 9.66311 20.2513 9.33913 20.0565 9.05292C19.8657 8.76274 19.6371 8.51628 19.3708 8.31354C19.1045 8.10683 18.8004 7.94982 18.4585 7.84249C18.1206 7.73516 17.7489 7.68149 17.3435 7.68149C16.6558 7.68149 16.0356 7.85839 15.4831 8.21218C14.9305 8.56597 14.4933 9.08472 14.1713 9.76845C13.8533 10.4482 13.6943 11.281 13.6943 12.2668C13.6943 13.2566 13.8553 14.0934 14.1773 14.7771C14.4992 15.4609 14.9405 15.9796 15.501 16.3334C16.0615 16.6872 16.6995 16.8641 17.415 16.8641C18.0789 16.8641 18.6573 16.7289 19.1502 16.4586C19.6471 16.1883 20.0307 15.8067 20.301 15.3138C20.5753 14.8169 20.7124 14.2325 20.7124 13.5607L21.1894 13.6502H17.6953V12.1297H22.4953V13.519C22.4953 14.5446 22.2766 15.435 21.8394 16.1903C21.4061 16.9416 20.8058 17.522 20.0386 17.9314C19.2754 18.3409 18.4009 18.5456 17.415 18.5456C16.3099 18.5456 15.34 18.2912 14.5052 17.7824C13.6744 17.2735 13.0264 16.5521 12.5614 15.6179C12.0963 14.6798 11.8637 13.5667 11.8637 12.2788C11.8637 11.3048 11.9989 10.4303 12.2692 9.65516C12.5395 8.88 12.9191 8.22211 13.4081 7.68149C13.901 7.1369 14.4794 6.72149 15.1432 6.43528C15.811 6.1451 16.5405 6 17.3315 6C17.9914 6 18.6056 6.09739 19.174 6.29218C19.7464 6.48696 20.2553 6.76323 20.7005 7.121C21.1497 7.47876 21.5214 7.9041 21.8155 8.39702C22.1097 8.88597 22.3084 9.42857 22.4118 10.0248H20.5216Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Uppercase;
